import React from 'react';
import { ListHeader, AccountingReference, IssuedCreditsReference, DueInterestReference, PayedByMonthReference, HomeVisitFeeReference, PrincipalsByMonthReference, PaymentsReference, PaymentsByMonthPerCreditReference } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var createPage = function createPage(title, Component) {
  var Page = function Page() {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
      title: title
    }), ___EmotionJSX(Component, null));
  };

  Page.displayName = title;
  return Page;
};

export var AccountingReferencePage = createPage('Счетоводство', AccountingReference);
export var IssuedCreditsPage = createPage('Кредити в момента на отпускането', IssuedCreditsReference);
export var DueInterestPage = createPage('Падежирали лихви', DueInterestReference);
export var PayedByMonthPage = createPage('Платени', PayedByMonthReference);
export var HomeVisitFeePage = createPage('Такса домашно посещение', HomeVisitFeeReference);
export var PrincipalsByMonthPage = createPage('Отпуснати кредити по месеци', PrincipalsByMonthReference);
export var PaymentsReferencePage = createPage('Детайли за плащания', PaymentsReference);
export var PaymentsByMonthPerCreditPage = createPage('Плащания по кредити и по месеци', PaymentsByMonthPerCreditReference);